import { CFG } from '../config';
import { sumMacros } from '../utils';
import type { DayData } from '../types';

interface Props {
  days: DayData[];
}

interface Tip {
  text: string;
  tag: string;
  cls: string;
}

export function SystemNotes({ days }: Props) {
  const { calories, protein, daysWithData } = sumMacros(days);
  const tips: Tip[] = [];

  if (daysWithData > 0) {
    const avgCal = calories / daysWithData;
    const avgP = protein / daysWithData;
    const [lo, hi] = CFG.calRange;

    if (avgCal < lo) {
      tips.push({
        text: `${Math.round(avgCal)} ккал/день -- ниже цели ${lo}. Не занижай слишком сильно, метаболизм замедлится.`,
        tag: 'alert', cls: 'tag-warn',
      });
    } else if (avgCal > hi) {
      tips.push({
        text: `${Math.round(avgCal)} ккал/день -- выше цели ${hi}. Дефицит не работает.`,
        tag: 'alert', cls: 'tag-warn',
      });
    }

    if (avgP < CFG.protein * 0.6) {
      tips.push({
        text: `Белка ${Math.round(avgP)}г из ${CFG.protein}г цели. На дефиците белок критичен -- мышцы горят.`,
        tag: 'alert', cls: 'tag-warn',
      });
    } else if (avgP < CFG.protein * 0.85) {
      tips.push({
        text: `Белка ${Math.round(avgP)}г из ${CFG.protein}г. Подтяни -- курица, яйца, творог.`,
        tag: 'alert', cls: 'tag-warn',
      });
    }

    if (daysWithData < 5) {
      tips.push({ text: `Записи за ${daysWithData}/7 дней.`, tag: 'habit', cls: 'tag-habit' });
    }
  }

  if (tips.length === 0) {
    tips.push({ text: 'Всё в норме. Продолжай.', tag: 'ok', cls: 'tag-ok' });
  }

  return (
    <div class="tips-section">
      <div class="tips-title">SYSTEM NOTES</div>
      {tips.map((t, i) => (
        <div key={i} class="tip-row">
          {t.text}
          <span class={`tip-tag ${t.cls}`}>{t.tag}</span>
        </div>
      ))}
    </div>
  );
}
